import requests from "./httpService";



const DriverServices = {
  getVendorAlotList: async (body) => {
    return requests.post(`/vendorAllot/list/`, body);
  },

  getVendorbyClientid: async (id,body) => {
    return requests.post(`/vendorAllot/${id}`,body);
  },

  AlotVendor: async (body) => {
    return requests.put(`/vendorAllot/allot`, body);
  },

  ModifyVendor: async (body) => {
    return requests.put(`/vendorAllot/modify`, body);
  },
};

export default DriverServices;
